<template>
  <div class="container">
    <div class="footprint-bg" :style="{ backgroundImage: `url(${bgImg})` }"></div>

    <div class="header">
      <button class="back-btn" @click="goBack">返回</button>
      <h2>个人足迹</h2>
    </div>

    <div class="content-wrap">
      <div class="empty-tip" v-if="footprintList.length === 0">
        <p>暂无私人足迹记录</p>
        <p class="empty-desc">前往首页地图页面，完成登记点亮城市，留下属于你个人的山河印记</p>
      </div>

      <div class="footprint-grid" v-else>
        <div
          class="footprint-item"
          v-for="item in footprintList"
          :key="item.id"
          @click="gotoDetail(item)"
        >
          <!-- 城市名称 + 到访次数放在同一行 -->
          <div class="city-row">
            <div class="city-name">{{ item.province }} · {{ item.city }}</div>
            <span class="visit-count">到访 {{ cityCountMap[item.city] || 1 }} 次</span>
          </div>
          <div class="time-text">
            {{ item.arriveTime }}
            <span v-if="item.leaveTime"> ~ {{ item.leaveTime }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCurrentUser, getFootprintList } from '@/api/footprint.js'

export default {
  name: 'PersonalFootprint',
  data() {
    return {
      bgImg: require('@/assets/grzj.webp'),
      footprintList: [],
      cityCountMap: {}
    }
  },
  mounted() {
    this.fetchPersonalFoot()
  },
  methods: {
    async fetchPersonalFoot() {
      try {
        await getCurrentUser()
        this.footprintList = await getFootprintList('personal')
        this.countCityVisit()
      } catch (err) {
        console.error('获取个人足迹失败', err)
        this.footprintList = []
      }
    },

    countCityVisit() {
      const map = {}
      this.footprintList.forEach(item => {
        if (!item.city) return
        if (!map[item.city]) {
          map[item.city] = 0
        }
        map[item.city]++
      })
      this.cityCountMap = map
    },

    goBack() {
      this.$router.go(-1)
    },

    gotoDetail(item) {
      this.$router.push({
        path: '/detail',
        query: {
          province: item.province,
          city: item.city,
          id: item.id
        }
      })
    }
  }
}
</script>

<style scoped>
/* ============================================================
   1. 页面骨架
   ============================================================ */
.container {
  width: 100%;
  height: 100vh;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.footprint-bg {
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background-size: cover;
  background-position: center;
  z-index: 0;
}

/* ============================================================
   2. Header：完美复刻个人中心的高光玻璃导航
   ============================================================ */
.header {
  position: relative;
  z-index: 10;
  flex-shrink: 0;
  height: clamp(48px, 7vh, 68px); 
  display: flex;
  align-items: center;
  padding: 0 clamp(16px, 3vw, 24px); 
  box-sizing: border-box;
  
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0.05));
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.back-btn {
  border-radius: 6px; 
  height: clamp(24px, 3.2vh, 28px);
  padding: 0 clamp(8px, 1.2vw, 14px);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.15));
  color: #fff;
  font-weight: 600;
  border: 1px solid rgba(255, 255, 255, 0.6);
  box-shadow: 
    0 2px 6px rgba(0, 0, 0, 0.1),
    inset 0 1px 2px rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(4px);
  font-size: clamp(11px, 1.1vw, 14px);
  line-height: 1.2; 
  cursor: pointer;
  flex-shrink: 0;
  transition: all 0.2s ease;
  text-shadow: 0 1px 2px rgba(0,0,0,0.15);
}
.back-btn:hover {
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0.3));
  transform: translateY(-1px);
}
.back-btn:active {
  transform: translateY(1px) scale(0.96);
  box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.15);
}

.header h2,
div.header h2 {
  position: absolute !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  margin: 0 !important;
  color: #2c3e50 !important; 
  font-size: clamp(16px, 2.2vw, 22px) !important; 
  font-weight: 900 !important; 
  letter-spacing: 3px !important; 
  white-space: nowrap !important;
  pointer-events: none !important;
  line-height: 1.2 !important;
  text-shadow: 
    0 2px 4px rgba(255, 255, 255, 0.9),
    0 4px 12px rgba(255, 255, 255, 0.6),
    0 1px 0px rgba(255, 255, 255, 1) !important;
}

/* ============================================================
   3. 内容区域：弹性撑满剩余空间
   ============================================================ */
.content-wrap {
  position: relative;
  z-index: 2;
  padding: clamp(12px, 2vw, 20px);
  box-sizing: border-box;
  width: 100%;
  max-width: 1100px; 
  margin: 0 auto;
  
  flex: 1; 
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
}

.empty-tip {
  text-align: center;
  margin-top: clamp(40px, 10vh, 100px);
  color: #fff;
  font-size: clamp(14px, 1.5vw, 18px);
}
.empty-desc {
  opacity: 0.8;
  margin: clamp(6px, 1.5vh, 12px) 0;
  font-size: clamp(11px, 1.2vw, 14px);
}

/* ============================================================
   4. 网格与卡片：完美自适应 + 高光琉璃
   ============================================================ */
.footprint-grid {
  display: grid;
  /* 默认（大屏幕及电脑端）：绝对锁定一行 3 块 */
  grid-template-columns: repeat(3, 1fr);
  gap: clamp(10px, 1.5vw, 16px);
}

/* 👇 小屏幕（比如手机横屏、或者较窄的窗口）：锁定一行 2 块 */
@media (max-width: 900px) {
  .footprint-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

.footprint-item {
  position: relative; 
  border-radius: 12px;
  padding: clamp(10px, 1.2vw, 16px) clamp(14px, 1.8vw, 22px); 
  cursor: pointer;
  transition: all 0.25s ease;
  overflow: hidden;
  
  background: rgba(255, 255, 255, 0.45); 
  backdrop-filter: blur(12px); 
  -webkit-backdrop-filter: blur(12px); 
  
  border: 1px solid rgba(255, 255, 255, 0.7); 
  box-shadow: 
    0 8px 24px rgba(0, 0, 0, 0.1), 
    0 2px 6px rgba(0, 0, 0, 0.05),
    inset 0 1px 2px rgba(255, 255, 255, 0.8);
}

.footprint-item::before {
  content: '';
  position: absolute;
  left: clamp(6px, 0.8vw, 10px); 
  top: clamp(12px, 1.5vh, 18px); 
  bottom: clamp(12px, 1.5vh, 18px); 
  width: 4px; 
  background: #FAB8CF; 
  border-radius: 4px; 
}

.footprint-item:hover {
  transform: translateY(-3px);
  background: rgba(255, 255, 255, 0.6);
  box-shadow: 
    0 12px 32px rgba(0, 0, 0, 0.15), 
    inset 0 1px 3px rgba(255, 255, 255, 0.9);
}

/* ============================================================
   5. 卡片内部文字自适应
   ============================================================ */
.city-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: clamp(6px, 1vw, 10px);
  margin-bottom: clamp(4px, 0.8vh, 8px);
}

.city-name {
  font-size: clamp(14px, 1.4vw, 17px);
  font-weight: 800;
  color: #2c3e50;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.visit-count {
  font-size: clamp(10px, 1vw, 12px);
  color: #409eff;
  background: rgba(236, 245, 255, 0.8);
  border: 1px solid rgba(217, 236, 255, 0.9);
  border-radius: 999px;
  padding: 2px clamp(6px, 0.8vw, 10px);
  flex-shrink: 0;
  font-weight: 600;
  box-shadow: 0 1px 2px rgba(0,0,0,0.05);
}

.time-text {
  font-size: clamp(11px, 1.1vw, 13px);
  color: #555;
  font-weight: 500;
}
</style>